module.exports = __webpack_public_path__ + "img/terrace2.16cfcf83.jpeg";